module.exports = __webpack_public_path__ + "static/media/gcdef_10024.f5301ecc.ico";